export const List = () => import('./List.vue');
export const Upload = () => import('./Upload.vue');
export const Create = () => import('./Create.vue');

